import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, Input, OnChanges, EventEmitter, Output, OnDestroy } from '@angular/core';
import { RegisterOfBenefactorsService } from '../../register-of-benefactors.service';
import { RegisterOfBenefactorsEventType } from '../../register-of-benefactors.event.type';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { BenefactorDataModel } from '../../../models/benefactorData';
import { TweenMax, Quint } from 'gsap';
import { Bank } from './../../../models/banks';
import { Observable } from 'rxjs/Observable';
import { EventTypes } from '../../../../shared/EventTypes';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { ListItem } from '../../../../shared/list-confirmation/model/list-item';
import { CpfCnpjPipe } from '../../../../shared/cpf-cnpj.pipe';
import { Account } from '../../../../autentication/models/account';
import { AutenticationService } from '../../../../autentication/autentication.service';
import { ThemeService } from '../../../../shared/theme-service/theme.service';
import { Auth } from '../../../../autentication/Auth';
import { ModalErrorEventType } from '../../../../shared/modal-error/modal-error.event.type';
import { Ownership } from '../../../models/ownership';
import { AccountNumberPipe } from '../../../../shared/account-number.pipe';

@Component({
	selector: 'app-benefactor-confirmation',
	templateUrl: './benefactor-confirmation.component.html',
	styleUrls: ['./benefactor-confirmation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class BenefactorConfirmationComponent implements OnInit, OnDestroy {

	@Input() benefactorData: BenefactorDataModel;
	@Input() benefactorDelete: BenefactorDataModel;
	@Input() submited = false;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() setTitle: EventEmitter<any> = new EventEmitter<any>();
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();

	private view = '[data-component="benefactor-confirmation"]';
	private confirmList: Array<ListItem> = [];
	private sendConfirmedBenefactor = false;
	public activeBackButton = false;
	public active = false;
	public disabled = false;
	public isAttendant = false;
	public ownerships: Array<Ownership> = [];
	public form: FormGroup;

	constructor(private registerOfBenefactorsService: RegisterOfBenefactorsService, private autenticationService: AutenticationService, private themeService: ThemeService) {
		this.ownerships = [new Ownership(1, 'Mesma Titularidade'), new Ownership(2, 'Outra Titularidade')];
	}

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();

		AppEventDispatcher.listen(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_CONFIRMATION, data => {
			this.active = true;
			this.show();

			this.showStepButtons.emit(false);
		});

		AppEventDispatcher.listen(RegisterOfBenefactorsEventType.BENEFACTOR.CONFIRM_DATA, () => {
			if (!this.benefactorDelete) {
				this.send();
			} else {
				this.openModalDelete();
			}
		});

		AppEventDispatcher.listen(ModalErrorEventType.MODAL.OK, data => {
			this.send();
		});

		AppEventDispatcher.listen(ModalErrorEventType.MODAL.CANCEL, data => {
			this.hide();
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_CONFIRMATION);
		AppEventDispatcher.removeListener(RegisterOfBenefactorsEventType.BENEFACTOR.CONFIRM_DATA);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.OK);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.CANCEL);
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
		this.setForm.emit(this.form);

		if (this.sendConfirmedBenefactor) {
			this.send();
		}
	}

	show() {
		const title = this.benefactorDelete ? 'Confirmação de exclusão de favorecido' : (this.benefactorData.id ? 'Confirmação de alteração de favorecido' : 'Confirmação de inclusão de favorecido');

		this.setTitle.emit({
			title: title
		});

		this.buildConfirmList();

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });
		});

	}

	buildConfirmList() {
		this.confirmList = [];
		this.confirmList.push(new ListItem('Banco:', this.benefactorData.bankDesc, 'cls_mask'));
		if (this.benefactorData.modality !== 'PG') {
			this.confirmList.push(new ListItem('Agência:', this.benefactorData.agency, 'cls_mask'));
		}
		const accNumPipe = new AccountNumberPipe();
		this.confirmList.push(new ListItem('Conta:', accNumPipe.transform(this.benefactorData.accountNumber), 'cls_mask'));

		const ownershipLabel = this.ownerships[this.benefactorData.ownership - 1].name;
		this.confirmList.push(new ListItem('Titularidade:', ownershipLabel, 'cls_mask'));


		if (this.benefactorData.name) {
			this.confirmList.push(new ListItem('Nome do Favorecido:', this.benefactorData.name, 'cls_mask'));
		}

		if (this.benefactorData.cpfCnpj) {
			const CP = new CpfCnpjPipe();
			this.confirmList.push(new ListItem('CPF/CNPJ:', CP.transform(this.benefactorData.cpfCnpj.replace(/\D/g, '')), 'cls_mask'));
		}


		if (this.benefactorData.modality === 'CC') {
			this.confirmList.push(new ListItem('Modalidade:', 'Conta Corrente'));
		} else if (this.benefactorData.modality === 'PP') {
			this.confirmList.push(new ListItem('Modalidade:', 'Conta Poupança'));
		} else if (this.benefactorData.modality === 'PG') {
			this.confirmList.push(new ListItem('Modalidade:', 'Conta Pagamento'));
		}

		this.benefactorData.resumeList = this.confirmList;
	}

	addAuthToken() {
		Auth.passToken = this.form.value.token ? this.form.value.token : '';
		Auth.assinaturaEletronica = this.form.value.eletronicSignature ? this.form.value.eletronicSignature : '';
	}

	send() {
		this.preload(true);
		this.submited = false;
		this.disabled = true;
		this.addAuthToken();

		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(dataSignature => {

			if (dataSignature.Sucesso) {

				if (!this.benefactorDelete) {
					this.registerOfBenefactorsService.save(this.benefactorData).subscribe(data => {

						this.benefactorData.success = true;
						this.benefactorData.message = data.Mensagem;

						this.disabled = false;

						this.hide();

					}, error => {
						this.benefactorData.success = false;
						this.disabled = false;
						AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
						this.preload(false);
					});
				} else {
					this.registerOfBenefactorsService.delete(this.benefactorData.id).subscribe(data => {

						this.benefactorData.success = true;
						this.benefactorData.message = data.Mensagem;

						this.disabled = false;

						this.hide();

					}, error => {
						this.benefactorData.success = false;
						this.disabled = false;
						AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
						this.preload(false);
					});
				}
			}
		}, error => {
			this.preload(false);
			this.disabled = false;
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			TweenMax.delayedCall(.5, () => {
				const containerHeight = this.getStepHeight();
				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			});
		});
	}

	hide() {
		this.preload(true);
		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(RegisterOfBenefactorsEventType.STEPS.BENEFACTOR_ADD.BENEFACTOR_ADD, { show: false });
			TweenMax.to(this.view, .8, {
				delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
					this.active = false;
					this.preload(false);
				}
			});
		});
	}

	openModalDelete() {
		$('[data-component="modal-error"]').appendTo('body');
		AppEventDispatcher.dispatch(EventTypes.MODAL_ERROR.MODAL_ERROR,
			{
				show: true,
				title: 'Aviso!',
				text: `A exclusão deste favorecido não poderá ser desfeita. Deseja continuar?`
			}
		);
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="add-benefactors"] .content', show: active, delay: delay });
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	public getMessageConfirmedBenefactor(message: boolean) {
		this.sendConfirmedBenefactor = message;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/register-of-benefactors/add-benefactors/benefactor-confirmation/benefactor-confirmation.component.ts